import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { useComponentDefaultProps } from '@mantine/styles';
import React, { forwardRef } from 'react';
import { useModalBaseContext } from '../ModalBase.context.js';
import useStyles from './ModalBaseOverlay.styles.js';
import { Transition } from '../../Transition/Transition.js';
import { Overlay } from '../../Overlay/Overlay.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var defaultProps = {};
var ModalBaseOverlay = forwardRef(function (props, ref) {
  var ctx = useModalBaseContext();

  var _a = useComponentDefaultProps("".concat(ctx.__staticSelector, "Overlay"), defaultProps, props),
      onClick = _a.onClick,
      transitionProps = _a.transitionProps,
      style = _a.style,
      className = _a.className,
      others = __objRest(_a, ["onClick", "transitionProps", "style", "className"]);

  var _useStyles = useStyles(null, ctx.stylesApi),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var handleClick = function handleClick(event) {
    onClick == null ? void 0 : onClick(event);
    ctx.closeOnClickOutside && ctx.onClose();
  };

  return /* @__PURE__ */React.createElement(Transition, __spreadProps(__spreadValues(__spreadValues({
    mounted: ctx.opened
  }, ctx.transitionProps), transitionProps), {
    transition: "fade"
  }), function (transitionStyles) {
    return /* @__PURE__ */React.createElement(Overlay, __spreadValues({
      ref,
      onClick: handleClick,
      fixed: true,
      style: __spreadValues(__spreadValues({}, style), transitionStyles),
      className: cx(classes.overlay, className),
      zIndex: ctx.zIndex
    }, others));
  });
});
export { ModalBaseOverlay };